import type { SVGProps } from 'react'

export function UserAdd(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M14.8947 20.3684C14.8947 17.8105 11.7843 15.7368 7.94737 15.7368C4.11044 15.7368 1 17.8105 1 20.3684M19.5263 16.8947V13.4211M19.5263 13.4211V9.94737M19.5263 13.4211H16.0526M19.5263 13.4211H23M7.94737 12.2632C5.38942 12.2632 3.31579 10.1895 3.31579 7.63158C3.31579 5.07363 5.38942 3 7.94737 3C10.5053 3 12.5789 5.07363 12.5789 7.63158C12.5789 10.1895 10.5053 12.2632 7.94737 12.2632Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
